import { render, staticRenderFns } from "./programAreaIcon.vue?vue&type=template&id=24f692ae"
import script from "./programAreaIcon.vue?vue&type=script&lang=js"
export * from "./programAreaIcon.vue?vue&type=script&lang=js"
import style0 from "./programAreaIcon.vue?vue&type=style&index=0&id=24f692ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports